import { 
	getters as $G,
	actions as $A,
	mutations as $M
} from '../types';


const state = {
    drawerOpen: false,
    currentVersionDate: new Date(),
    latestVersionDate: new Date()
};
  
const getters = {
    [$G.APP_UPDATE_REQUIRED](state) {
        return state.currentVersionDate < state.latestVersionDate;
    }
};
  
const actions = {
	[$A.APP_DRAWER_OPEN](context) {
		if(!context.state.drawerOpen)
			context.commit($M.APP_DRAWER_OPEN);
	},
	[$A.APP_DRAWER_CLOSE](context) {
		if(context.state.drawerOpen)
			context.commit($M.APP_DRAWER_CLOSE);
	},
	[$A.APP_DRAWER_TOGGLE](context) {
		context.dispatch(context.state.drawerOpen ? $A.APP_DRAWER_CLOSE : $A.APP_DRAWER_OPEN);
    },
    [$A.APP_LATEST_VERSION_DATE_SET](context, payload) {
        context.commit($M.APP_LATEST_VERSION_DATE_SET, {
            date: payload.date
        });
    }
};
  
const mutations = {
	[$M.APP_DRAWER_CLOSE](state) {
		state.drawerOpen = false;
	},
	[$M.APP_DRAWER_OPEN](state) {
		state.drawerOpen = true;
    },
    [$M.APP_LATEST_VERSION_DATE_SET](state, payload) {
        state.latestVersionDate = payload.date;
    }
};
  
export default {
	state,
	getters,
	actions,
	mutations
};
